import { Fragment } from 'react';

import styled from 'styled-components';

import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type ValueListItemType = {
  value: number | string;
  label: string;
  labelColor?: Color;
  valueColor?: Color;
};

export type ValueListProps = {
  items: Array<ValueListItemType>;
  hasBorder?: boolean;
};

type ValueListItemProps = {
  item: ValueListItemType;
  hasLeftBorder?: boolean;
};

const ValueListItem = ({ item }: ValueListItemProps) => (
  <ValueListItemContainer>
    <Text color={item.valueColor ?? 'textPrimary'} font="bold14" text={item.value} />
    <Text color={item.labelColor ?? 'textSecondary'} font="regular12" text={item.label} />
  </ValueListItemContainer>
);

const ValueListItemContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',

  ':not(&:last-child)': {
    paddingRight: pxToRem(16),
    borderRight: `${pxToRem(1)} solid ${theme.color.border10}`,
  },
});

export const ValueList = ({ items, hasBorder = false }: ValueListProps) => (
  <Stack orientation="horizontal" space={4}>
    {items.map((item, index) => (
      <Fragment key={item.label}>
        {hasBorder && index === 0 && <Separator orientation="horizontal" />}
        <ValueListItem item={item} />
      </Fragment>
    ))}
  </Stack>
);
